import {
  CREATOR_ROLES,
  OPERATIONS_ROLES,
  USER_ROLES
} from './../constant/enum/user_roles'

export function filterVerticals(
  verticals: VerticalObjectType[],
  roleType: keyof typeof USER_ROLES,
  portalType: 'creator' | 'client_enterprise' | 'client_sme'
): VerticalObjectType[] {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const roleTypeAry: any = roleType ? roleType.split(',') : []
  const isOperationalPortal =
    roleTypeAry.findIndex(
      (_roleType: keyof typeof OPERATIONS_ROLES) => OPERATIONS_ROLES[_roleType]
    ) !== -1

  if (!(roleType in CREATOR_ROLES) && isOperationalPortal) return verticals

  switch (portalType) {
    case 'creator':
      switch (roleType) {
        case CREATOR_ROLES.writer:
          return verticals.filter(vertical => {
            return vertical.category.key === 'text'
          })

        case CREATOR_ROLES.editor:
          return verticals.filter(vertical => {
            return ['text', 'translation'].includes(vertical.category.key)
          })

        case CREATOR_ROLES.translator:
          return verticals.filter(vertical => {
            return vertical.category.key === 'translation'
          })

        case CREATOR_ROLES.designer:
          return verticals.filter(vertical => {
            return vertical.category.key === 'design'
          })

        default:
          return verticals
      }

    case 'client_sme': {
      return verticals.filter(vertical =>
        vertical.display.includes('client_sme')
      )
    }

    case 'client_enterprise': {
      return verticals.filter(vertical =>
        vertical.display.includes('client_enterprise')
      )
    }

    default:
      return verticals.filter(vertical => vertical.display.length === 0)
  }
}
